<script lang="ts">
  import { tick } from 'svelte';
  import type { BackendActor } from '../actor';
  import type { InLobbyState } from '../gameState';
  import OutsideLayout from './OutsideLayout.svelte';
  import { assets, playSound } from '../assets';

  export let actor: BackendActor;
  export let state: InLobbyState;
  let name: string;
  let starting = false;
  let leaving = false;
  let messageCount = 0;
  let message = '';
  let chatEl: HTMLDivElement;

  async function startGame() {
    starting = true;

    try {
      await actor.start_game();
      playSound(assets.sounds.horn);
    } catch {
    } finally {
      starting = false;
    }
  }
  async function leave() {
    leaving = true;

    try {
      await actor.leave_lobby();
    } catch {
    } finally {
      leaving = false;
    }
  }

  async function onChat() {
    const msg = message.trim();
    if (msg === '') return;
    message = '';
    await actor.chat_lobby(msg);
  }

  $: {
    if (state.chat.length > messageCount && chatEl) {
      tick().then(() => {
        chatEl.scrollTop = chatEl.scrollHeight;
      });
      messageCount = state.chat.length;
    }
  }
</script>

<OutsideLayout>
  <div class="flex gap-6 justify-center">
    {#if state.gameInProgress}
      <button class="btn btn-primary" disabled>Game in progress</button>
    {:else if state.players.length < 2}
      <button class="btn btn-primary" disabled
        >Need at least 2 players to start</button
      >
    {:else}
      <button
        on:click={() => startGame()}
        class="btn btn-primary {starting && 'loading'}">Start game</button
      >
    {/if}
  </div>
  <div
    class="mt-16 max-w-4xl mx-auto flex flex-col md:flex-row gap-8 h-[300px]"
  >
    <div class="flex-1 flex flex-col">
      <div class="flex items-center justify-between">
        <h2
          class="font-body font-medium tracking-wide uppercase text-md text-gray-300"
        >
          Players
        </h2>
        <button
          on:click={leave}
          class="btn btn-outline btn-sm {leaving && 'loading'}"
          disabled={leaving}>Leave Lobby</button
        >
      </div>
      <ul
        class="flex-1 border mt-4 bg-white/80 text-black font-medium p-4 text-xl space-y-2 text-left overflow-auto"
      >
        {#each state.players as player}
          <li>{player.name}</li>
        {/each}
      </ul>
    </div>
    <div class="flex-[2] text-left text-black text-sm flex flex-col">
      <h2
        class="font-body font-medium tracking-wide uppercase text-md text-gray-300 h-8 flex items-center"
      >
        Chat
      </h2>
      <div
        class="flex-1 overflow-auto bg-white/80 p-4 mt-4 h-80 md:h-auto"
        bind:this={chatEl}
      >
        <!-- <div class="italic mb-2">You have joined the chat.</div> -->
        {#each state.chat as msg}
          <div class="flex gap-2">
            <div class="">
              {new Date(Number(msg.timestamp / 1000000n)).toLocaleTimeString()}
            </div>
            <div class="font-bold">{msg.name}</div>
            <div>{msg.message}</div>
          </div>
        {/each}
      </div>
      <form
        class="pt-4 flex gap-2"
        on:submit|preventDefault|stopPropagation={onChat}
      >
        <input
          type="text"
          class="input input-sm bg-white/80 flex-1 rounded-none"
          placeholder="Type message..."
          bind:value={message}
        />
        <button class="btn btn-primary btn-sm">Send</button>
      </form>
    </div>
  </div>
</OutsideLayout>
